import React,{useState,useContext,useEffect,useRef} from "react";
import Header from "./Header"; // Import Header from layout folder
import Footer from "./Footer"; // Import Footer

const Layout = ({ children, showHeader = true,showFooter = true  }) => {

const [isScrolled, setIsScrolled] = useState(false);
const scrollableRef = useRef(null); // Ref for the scrollable element

useEffect(() => {
    const handleScroll = () => {
      const scrollableElement = scrollableRef.current;

      if (scrollableElement) {
        const scrollTop = scrollableElement.scrollTop;
        const offsetTop = scrollableElement.offsetTop;

        if (scrollTop >= offsetTop) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }
    };

  const scrollableElement = scrollableRef.current;

    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div className={`Favourites menupages ${isScrolled ? "act" : ""}`}>
       {showHeader && <div className="innerhead"><Header /></div>}
          <main className="content">{children}</main>
          {showFooter && <div className="footer_menu menuactive-"><Footer /></div> }
    </div>
  );
};

export default Layout;